import { Job } from 'types/jobs';

import { SubscriptionTypes } from 'constants/enums';

/**
 * Checks if the job is an automatically created free job
 * (Free job without edit date)
 */
export const isAutoCreatedFreeJob = (job: Job | null | undefined): boolean => {
  if (!job) return false;

  return job.subscriptionType === SubscriptionTypes.Free && !job.editDate;
};

/**
 * Returns the display title for the job.
 * For automatically created jobs, returns null (to use the translated label),
 * for others - the actual job title
 */
export const getDisplayJobTitle = (
  job: Job | null | undefined
): string | null => {
  if (!job) return null;

  if (isAutoCreatedFreeJob(job)) {
    return null;
  }

  return job.title;
};
